const e = {
  name: "RevenueAccelerate",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.1,0.9c-1.2-1.2-3.1-1.2-4.2,0L4.2,14.6L9.6,20l-5.4,5.4l13.7,13.7c1.2,1.2,3.1,1.2,4.2,0l17-17
			c1.2-1.2,1.2-3.1,0-4.2L22.1,0.9z M19.3,2.3c0.4-0.4,1-0.4,1.4,0l17,17c0.4,0.4,0.4,1,0,1.4l-17,17c-0.4,0.4-1,0.4-1.4,0l-2.8-2.8
			L31.4,20L16.5,5.1L19.3,2.3z M15.1,6.5L28.6,20L15.1,33.5l-3.6-3.6l9.9-9.9l-9.9-9.9L15.1,6.5z M18.6,20l-8.5,8.5L7,25.4l5.4-5.4
			L7,14.6l3.1-3.1L18.6,20z"/>
		<path class="st0" d="M3,17c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C6,18.3,4.7,17,3,17z M2,20c0-0.6,0.4-1,1-1s1,0.4,1,1
			s-0.4,1-1,1S2,20.5,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as RevenueAccelerate
};
